import { Html } from "@react-three/drei";
import { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import * as THREE from "three";

const DimensionLabelComponent = forwardRef(({
  params,
  position,
  label,
  visible,
  isMobile,
  isSmall,
  inverse = false,
  distanceScale = 0.8
  // offsetDirection,
}, ref) => {
  const htmlRef = useRef(null);
  const labelDivRef = useRef(null);
  
  // Store position and text in state - we'll update these directly via imperative handle
  const [currentPosition, setCurrentPosition] = useState(position || new THREE.Vector3());
  const [currentText, setCurrentText] = useState(label || '');
  
  // Store refs to avoid unnecessary updates
  const lastPositionRef = useRef(null);
  const lastTextRef = useRef(null);

  // Sync props to state when they change (for initial render)
  useEffect(() => {
    if (position) {
      setCurrentPosition(position);
      lastPositionRef.current = position;
    }
    if (label !== undefined) {
      setCurrentText(label);
      lastTextRef.current = label;
    }
  }, [position, label]);

  // Expose methods to update position and text directly
  useImperativeHandle(ref, () => ({
    updatePosition: (newPosition) => {
      // Only update if position actually changed (avoid unnecessary re-renders)
      if (newPosition && (!lastPositionRef.current || 
          !lastPositionRef.current.equals(newPosition))) {
        setCurrentPosition(newPosition);
        lastPositionRef.current = newPosition;
      }
    },
    updateText: (newText) => {
      // Only update if text actually changed (avoid unnecessary re-renders)
      if (newText !== undefined && newText !== lastTextRef.current) {
        setCurrentText(newText);
        lastTextRef.current = newText;
      }
    },
    getObject: () => htmlRef.current
  }), []);

  return (
    <Html
      ref={htmlRef}
      position={currentPosition}   
      zIndexRange={[5, 0]}   
      center
      occlude
      style={{ opacity: visible ? 1 : 0, transition: "opacity 0.25s", color: params.labelColour }}
    >      
      <div
        ref={labelDivRef}
        className={
          isSmall || isMobile
            ? inverse
              ? "modelviewer-label-small-inverse"
              : "modelviewer-label-small"
            : inverse? "modelviewer-label-inverse" : "modelviewer-label"
        }
      >
        {currentText}
      </div>
    </Html>
  );
});

DimensionLabelComponent.displayName = 'DimensionLabel';
export const DimensionLabel = DimensionLabelComponent;
